define('plugin/bonus/model/BonusModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Invoice model
     *
     * @class InvoiceModel
     */
    return BaseModel.extend({

        urlRoot: '/ext/bonus/details/id',

        defaults: {
            id: null,
            client_id: null,
            datetime: null,
            description: '',
            is_valid: 0,
            object_id: null,
            type: 'promotion',
        },

        initialize: function () {
            BaseModel.prototype.initialize.apply(this, arguments);

        },

        parse: function (resp, options) {
            var result = BaseModel.prototype.parse.apply(this, [resp, options]);

            return result;
        },

        confirmPayment: function () {
            var options = {
                confirm: true,
                url: this.urlRoot + '/' + this.get('id')
            };
            return this.syncWithPromise('update', options);
        },

    });

});
